import * as THREE from "three";
import React, { Component } from "react";
import * as cuBuilding from "./building_pricing/pricingReducer";
import * as cuComponent from "./building_component/componentReducer";
import * as validate from "../../Components/Modals/validations";
import TWEEN from "@tweenjs/tween.js";
import * as utils from "./utils";
import { cupolaEditValidation, editValidation, wallNameArrForValid } from "../../utils/Validation";
import { controls } from "./common/eventReducer";
import { LEAN_TYPE_NUM_TO_STR, ManufacturesDefaultDetails } from "../../Constants/constant";
import { setQuoteStateCountForNonLoggedIn } from "../../action";
import setBuildingData from "../../helpers/building/building_style/setBuildingData.helper";
import setPricingData from "../../helpers/building_pricing/setPricingData.helper";
import setPricingDataForLeanto from "../../helpers/lean_building_pricing/setPricingDataForLeanto.helper";
import setPricingDataForLeantoComparision, { NoCompareData } from "../../helpers/building_comparison_pricing/setPricingDataForLeantoComparision.helper";
import { AddDoorComponentonWall, calculateLegsCount, commonFunctionForColor, handleBookDemo, handleCommonAttribute, handleShowMeasure, updateBreezewayFrameAndStorages } from "../../helpers/common/common.helper";
import centerBuildingsWallOptionsHelpers, { fullWallClosed, fullWallOpened, handleCutPanelWall, setActiveBuildingWall } from "../../helpers/building/building_wall/centerBuildingsWallOptions.helpers";
import leanToWallOptionHelpers from "../../helpers/lean_building_pricing/lenatoWallOptions.helpers";
import utilityStorageOptionsHelpers from "../../helpers/building_pricing/utility_pricing/utilityStorageOptions.helpers";

import {
	makeDimensionUpdateBack,
	updateTemplateWidthB,
	makeDimensionUpdateLeft,
	updateTemplateWidthL,
	makeDimensionUpdateRight,
	updateTemplateWidthR,
	makeDimensionUpdateFront,
	updateTemplateWidthF,
	selectleanBuilding,
	selectTrussForLean
} from "../../helpers/lean_building_pricing/leanBuilding.helper";

import { changeBuildingDimension, makeDimensionArray } from "../../helpers/building/building_style/centreBuilding.helper";
import { makeComponentArray, makeComponentArrayForOtherBuilding } from "../../helpers/building_component/doorWindows.helper";
import createBuildingStyleChanges from "../../helpers/building/building_style/buildingStyleChanges.helper";
import { updateColor } from "../../helpers/building/building_color/building.color.helper";
import { getSidingOrientationOptions, handleAllVerticalChange, initBuildingSidingMaterialOptions } from "../../helpers/building/building_material/buildingMaterial.helper";
import { changeBuildingRoof as changeBuildingRoofHelper } from "../../helpers/building/building_style/buildingStyleChanges.helper";
import { formatTrussOptionsByGauge, getGaugeRoofCost } from "../../helpers/building_pricing/buildingPricing.helper";
import {
	handleManufacturerChange,
	handleManufacturerModal,
	setDealerStateList,
	setDiscount,
	stateManufacturerChange,
	stateManufacturerDataChange,
	updateManufacture
} from "../../helpers/manufacturer_auth/manufacturerHelper";
import {
	handleAddAdditionComponent,
	handleCertificateChange,
	handleExtraElements,
	handleExtraInformation,
	handleNewComponent,
	handleOverHang,
	handleOverHangSelection,
	handleSurfaceChange,
	updateOverHang
} from "../../helpers/extra_options_pricing/extraOptions.helper";

import { params, const_var } from "./common/stateObjects";
import { handleAddLeantoSection, handleLeanToPorcheSection } from "../../helpers/lean_building_pricing/leanBuildingCalculation.helper";
import { EditloadDefaultBuilding, loadDefaultBuilding } from "../../helpers/building/load_building/loadBuilding";
import {
	addCupola,
	calcOverhangSize,
	gaugeActionData,
	handlCupolaPositionOnDimensionChange,
	handleCupolaData,
	loadCupolaInEditMode,
	removeAllCupolas,
	updataOrRemoveCupola,
	updateCupolasArray,
	updateCupolasData
} from "../../helpers/building_component/buildingComponent.helper";
import {
	addCustomComponent,
	reSelExtEle,
	changePorchDimension,
	editActionAfterPreparingData,
	onSubmitState,
	setDefaultConfiguration,
	showMoreLess,
	updateJTrim,
	updatePorchLengths,
	updateWainscot,
	widerlongeranimate,
	hidePriceForGableLeanTos,
	makeItCustomBuilding,
	checkChangeDimension,
	changeBuildingDimensionData,
	checkChangeBuildingRoof,
	changeBuildingRoofData
} from "../../helpers/building/building_config/buildingConfiguration.helper";
import {
	changeLeanStyle,
	checkChangeLeantoPosition,
	chnageLeanToPosition,
	updateBackLeanUtilityPosition,
	updateEndStoragePositionZ,
	updateFrontLeanUtilityPosition,
	updateLeanUtilityPosition,
	updateLeftLeanUtilityPosition,
	updateRightLeanUtilityPosition
} from "../../helpers/lean_building_pricing/lean_utiltiy/leanBuildingUtility.helper";
import { individuealLeanWallChange } from "../../helpers/lean_building_pricing/lean_building_wall/leanBuildingWall.helper";
import {
	addBackUtility,
	addBuildingUtility,
	addFrontUtility,
	addLeftUtility,
	addRightUtility,
	noBuildingUtility,
	toggleActionForUtility,
	utilityChangeByLength
} from "../../helpers/building/building_utility/buildingUtility.helper";
import {
	changeComponentData,
	changeDoorWindowSize,
	chnageComponentSize,
	handleAddDoorComponent,
	handleClearComponent,
	handleCustomComponent,
	headerSealChainHoistAction,
	updateDoorWindowIcons,
	UpdateDoorWindowPosition,
	updateDoorWindowPosition,
	updateDoorWindowsArray
} from "../../helpers/building_component/setDoorWindowDimension.helper";
import {
	handleDoorWindowInstallationFee,
	handleNewDiscount,
	handleOfferPriceCalculation,
	handleTax,
	handleTaxApicall,
	handleUpdatePaymentoption,
	taxDepositCalculation
} from "../../helpers/building_pricing/tax_discount_calculation/taxCalculation.helper";
import { handleInsulationData, handleInsulationForData } from "../../helpers/extra_options_pricing/extra.pricing.helper";
import {
	changeBuildingTypeName,
	changeCenterBuilding,
	checkOtherBuildingType,
	fullBuildingView,
	fullWrapClick,
	handleBuildingFlag,
	handleBuildingStyleChange,
	handleBuildingStyleTypeChange,
	handleChangeBuildingData,
	handleDefaultBuildingData,
	handleDeleteStateModal,
	handleKLinkExpire,
	handleSetDefaultConfiguration,
	handleSetFramevalue,
	handleSetupTween,
	handleShowCenterBuilding,
	handleShowSummary,
	handleToggleCheckbox,
	handleTrussChange,
	handleUpdatePostdata,
	selectCenterBuilding,
	SetPricingForComponent,
	showSingleSlope
} from "../../helpers/building/building_config/building.helper";
import {
	checkSharingAlertBox,
	checkSnowBuilding,
	dragUtilityPriceReset,
	globalZipState,
	handleAccordian,
	handleActiveTabPanel,
	handleAddRemoveComponent,
	handleAlert,
	handleAlertCancel,
	handleChangeAccordianBg,
	handleCloneComponent,
	handleClose,
	handleCloseDoorWindow,
	handleCompanySelection,
	handleConfirmAlert,
	handleDeviceCapture,
	handleEditComponentSize,
	handleGeneratePrintimages,
	handleIconClick,
	handleLoftChange,
	handlePublicEdit,
	handleRemoveComponent,
	handleSelectedTab,
	handleSelectedTabState,
	handleShowfeedbackData,
	handleShowWhatThis,
	resetAllEditValue,
	setComparisonBuildingLoader,
	SetPriceCompareForNonLoggedIn,
	setZipCodeValue,
	showHideTransulent
} from "../../helpers/common/otherOptions.helper";
import { hasDoublelegBaiserail } from "../../helpers/building_component/legs_condition.helper";
import { handleCompareSummaryModal, handleShowCompareModal, setBuildingComparisonData } from "../../helpers/building_comparison_pricing/buildingComparison.helper";
import { Controls } from "three";
export { params, const_var };
export const kFront = "front";
export const kBack = "back";
export const kLeft = "left";
export const kRight = "right";
export const kLeftCutPanel = "leftCutPanel";
export const kRightCutPanel = "rightCutPanel";
export const kFronttCutPanel = "frontCutPanel";
export const kBackCutPanel = "backCutPanel";
export const kYES = "YES";
export const kNO = "NO";
export const initialState = {
	mainTrussPosInfo: [],
	nonLoggedInpriceCompareData: null,
	leanToTrussPosInfo: {
		frontLeanTo: [],
		leftLeanTo: [],
		rightLeanTo: [],
		backLeanTo: []
	},
	isLeanDragging: false,
	wallCloseStateWrap: {},
	leftWallCloseState: 0,
	rightWallCloseState: 0,
	isShowEditIconSection: false,
	selectedCmpType: "none",
	isActiveWallSubTab: "center_building",
	isResetBuilding: false,
	isfullviewbuilding: false,
	infoMessage: false,
	oldFreeStandingData: {},
	doorWindowIconsPos: [],
	feetVal: 0,
	cupolaEditIconsPos: [],
	changeOtherBuildingTypeName: "",
	editDataChangeAction: "",
	AdditionComponentAdd: "",
	AdditionNewComponentAdd: "",
	isNeedToReRender: "NO",
	checkValidateKeyValue: false,
	selectedTrimColor: "",
	selectedWallColor: "",
	isFullyEnclosedChecked: false,
	isFullyEnclosedCheckedForFrontLeanTo: false,
	isFullyEnclosedCheckedForBackLeanTo: false,
	isFullyEnclosedCheckedForLeftLeanTo: false,
	isFullyEnclosedCheckedForRightLeanTo: false,
	fullyEnclosed: "",
	checkedBuildingType: "",
	ends: {},
	sides: {},
	lentoEnds: {},
	lentoSides: {},
	p_l_r: {},
	p_l_rL: {},
	p_l_rR: {},
	b_p_r: {},
	b_p_rR: {},
	jsonDataR: "",
	jsonDataL: "",
	frontlentoEnds: {},
	frontlentoSides: {},
	backlentoEnds: {},
	backlentoSides: {},
	leftlentoEnds: {},
	leftlentoSides: {},
	rightlentoEnds: {},
	rightlentoSides: {},
	selectedOption: null,
	c_m_a: [],
	b_m_i_w: [],
	const_var: const_var,
	isAllVerticalChecked: false,
	params: params,
	newColor: "",
	defaultRoof: "0",
	defaultBuilding: "",
	OlddefaultBuilding: "",
	b_m_i_w: "",
	selectedTabKey: "buildingtypetab",
	selectedTabstate: "statechange",
	isShowThankYou: false,
	isShowWhatThis: false,
	isShowfeedback: false,
	isShowfeedbackloader: false,
	iswelcomeModal: false,
	isShowSuccessOq: false,
	isShowSummaryModal: false,
	isShowComparePriceModal: false,
	screenShareModal: false,
	isShowPhotoModal: false,
	isShowDiscountsPanel: false,
	showDiscountBanners: false,
	isShowDiscountsModal: false,
	isShowOverlay: false,
	incClickTime: "",
	selectedManufacturer: 0,
	isShowShareModal: false,
	priceBookFile: "",
	alertUsedFor: "",
	isFullyOpenedChecked: false,
	isFullyOpenedCheckedForFrontLeanTo: false,
	isFullyOpenedCheckedForBackLeanTo: false,
	isFullyOpenedCheckedForLeftLeanTo: false,
	isFullyOpenedCheckedForRightLeanTo: false,
	showFullPageLoader: "",
	defaulProductLoad: false,
	holdPreviousRoofStyle: 3,
	holdCurrentRoofStyle: 3,
	emojiindex: 4,
	isShowPredesignOption: true,
	isMobileDraw: false,
	isShowBookDemo: true,
	selectedPiceAndSummaryMobileView: 0,
	copyShareText: "Copy Link",
	discount_banner: false,
	discount_Offers: [],
	discount_Offers_all: [],
	discount_Offers_end_date: "",
	showDiscountExpire: false,
	higherOfferPercentage: 0,
	updateStateForlean: false,
	isDealerDiscountBannerVisible: false,
	isShowDeletedStateManuModal: false
};
let activeWallP = "";
const reducer = (state = initialState, action) => {
	const newState = { ...state };
	switch (action.type) {
		case "SET_ADD_GABLE_LEAN_TOGGLE_VISIBILITY": {
			params.addGableLeanToggleVisibility = !!action.value;
			return {
				...state,
				color: action + Math.random(),
				action
			};
		}

		case "UPDATE_STATE": {
			return {
				...state,
				color: action + Math.random(),
				action
			};
		}

		case "STOP_LOADER": {
			return {
				...state,
				micro_loader: false
			};
		}

		case "setSelectedCmpType": {
			state.selectedCmpType = action.value;
			return {
				...state,
				action
			};
		}

		case "setIsShowEditIconSection": {
			state.isShowEditIconSection = action.value;
			return {
				...state,
				action
			};
		}

		case "changeLeanDragState": {
			state.isLeanDragging = action.isDrag;

			return {
				...state,
				action
			};
		}

		case "setMainTrussPosInfo": {
			state.mainTrussPosInfo = action.value;
			return {
				...state,
				action
			};
		}

		case "setTrussTypeName": {
			state.params.trussType = action.value;
			return {
				...state,
				action
			};
		}

		case "setLeanToTrussPosInfo": {
			state.leanToTrussPosInfo = {
				...state.leanToTrussPosInfo,
				...action.value.data
			};
			return {
				...state,
				action
			};
		}

		case "updateLeanToPosition": {
			return updateLeanUtilityPosition(state, action);
		}

		case "updateDoorWindowsArray":
			return updateDoorWindowsArray(state, action);

		case "updateDoorWindowPosition":
			return updateDoorWindowPosition(state, action);

		case "onDragUtilityPriceReset": {
			return dragUtilityPriceReset(state, action);
		}
		case "updateEditIconVisiblity":
			state.isShowEditIconSection = false;
			return {
				...state,
				action
			};

		case "updateEndStoragePositionZ":
			return updateEndStoragePositionZ(state, action);

		case "updateLeftLeanStoragePosition":
			return updateLeftLeanUtilityPosition(state, action);
		case "updateRightLeanStoragePosition":
			return updateRightLeanUtilityPosition(state, action);

		case "updateFrontLeanStoragePosition":
			return updateFrontLeanUtilityPosition(state, action);

		case "updateBackLeanStoragePosition":
			return updateBackLeanUtilityPosition(state, action);

		case "updateCupolasArray":
			return updateCupolasArray(state, action);

		case "updateCupolas":
			return updateCupolasData(state, action);

		case "updateDoorWindowLimitPosition": {
			return UpdateDoorWindowPosition(state, action);
		}

		case "changeDoorWindowSize":
			return changeDoorWindowSize(state, action);

		case "updateChangeSizeType":
			const doorIndex = const_var.newDoorsArray.findIndex((item) => item.uniqueId === action.doorUniqueId);
			if (doorIndex !== -1) {
				state.const_var.newDoorsArray[doorIndex].isCustomSizeChange = action.isCustomSizeChange;
			}
			return {
				...state,
				action
			};

		case "alertDone":
			return handleAlert(state, action);

		case "removeComponent":
			return handleRemoveComponent(state, action, cuComponent);

		case "showAlert":
			state.const_var.isShowAlert = !state.const_var.isShowAlert;
			state.const_var.alertUsedFor = action.alertText;

			state.const_var.showComponentEditBox = false;

			return {
				...state,
				action
			};

		case "setActiveBuildingWall":
			return setActiveBuildingWall(state, action);
		case "setWallCloseStateWrap":
			state.wallCloseStateWrap = {
				...state.wallCloseStateWrap,
				...action.value
			};
			return {
				...state,
				action
			};

		case "setLeftWallCloseState":
			if (action.key == "left") state.leftWallCloseState = action.value;
			if (action.key == "right") state.rightWallCloseState = action.value;
			return {
				...state,
				action
			};

		case "changeLeanStyle":
			return changeLeanStyle(state, action);
		case "COLOR":
			return updateColor(state, action);
			break;
		case "publicEditFun":
			return handlePublicEdit(state, action);
			break;
		case "ManageKlinkExpire":
			return handleKLinkExpire(state, action);
			break;
		case "CallPublicAPI":
			cuComponent.onResize();
			const_var.isShowEditConfigurationButton = action.value.data.status;

			return {
				...state,
				action
			};
			break;
		case "handleIconClick":
			return handleIconClick(state, action, utils);
			break;
		case "ShowHideTranslusant":
			return showHideTransulent(state, action, controls);
			break;
		case "manageSideLeanUI":
			state.params.manageSideLean = action.value;
			return {
				...state,
				action
			};
			break;
		case "BUILDING":
			return {
				...state,
				building: newState.building
			};
			break;
		case "changeOtherBuildingTypeName":
			return changeBuildingTypeName(state, action);
			break;
		case "updatePaymentOption":
			return handleUpdatePaymentoption(state, action);
			break;
		case "UPDATEWAINSCOTPRICEFLAG":
			let updateState = action.value;
			const_var.UpdatedPriceData.wainscot_price_changed = true;
			cuBuilding.cP();
			return {
				...state,
				newColor: updateState + new Date()
			};
			break;
		case "GAUGEACTION":
			return gaugeActionData(state, action, utils);

		case "handleCanopyCheckboxChange":
			params.canopy = !params.canopy;
			cuBuilding.BuildingUpdate(true);

			return {
				...state,
				action
			};

		case "handleCupola":
			return handleCupolaData(state, action);
		case "setPriceForCupola":
			if (action.flag === true) cuBuilding.cP("", undefined, "");
			return {
				...state,
				newColor: action.flag + action.length
			};
			break;
		case "commonActionCall":
			if (action.key == "closeInfo") {
				const_var.infoMessage = false;
			}
			if (action.key == "change_share_text") {
				state.copyShareText = "Copied";
			}
			return {
				...state,
				action
			};
			break;
		case "PRICEDATACERTIFICATION":
			return handleCertificateChange(state, action);

		case "changeBuildingOnCenter":
			return changeCenterBuilding(state, action, cuBuilding);
			break;
		case "changeProductStatus":
			state.params.display_product_status = action.event;
			return {
				...state,
				action
			};
			break;
		case "clearComponents":
			return handleClearComponent(state, action);
			break;

		case "ChangeBackgroundAccordingtoCon":
			return handleChangeAccordianBg(state);
			break;
		case "priceAPI":
			return {
				...state
			};
			break;
		case "DEFAULTBUILDINGDATA":
			return handleDefaultBuildingData(state, action, setBuildingData);
			break;
		case "SETDEFAULTCONFIGURATION":
			return handleSetDefaultConfiguration(state, action, cuBuilding);
			break;
		case "CheckDoorWindowsInstallationFees":
			return handleDoorWindowInstallationFee(state, action);
		case "CheckOtherBuildingType":
			return checkOtherBuildingType(state, action);
			break;
		case "CHANGEBUILDINGDATA":
			return handleChangeBuildingData(state, action, setBuildingData);
			break;
		case "SET_BUILDING_MATERIAL":
			initBuildingSidingMaterialOptions(state, action);
			return {
				...state,
				newColor: action.value
			};
		case "BUILDINGTYPECHANGE":
			buildingTypeChange(state, action.value);

			return {
				...state,
				newColor: action.value
			};
			break;
		case "ROOFSTYLECHANGE":
			let index = const_var.roof_style.findIndex((data) => data.roof_id == action.value);

			roofStyleChange(state, index, true, true);
			return {
				...state,
				newColor: action.value,
				defaultRoof: action.value
			};
			break;
		case "editActionAfterPreparingData":
			editActionAfterPreparingData(state, action.data, action.doorData, roofStyleChange);
			return {
				...state,
				editDataChangeAction: action
			};
			break;
		case "loadCupolaInEditMode":
			let isOldQuotes = "No";
			if (params.cupola && params.cupolaObj && action.data.cupola_price && !action.data.cupolaEntries) isOldQuotes = "Yes";
			loadCupolaInEditMode(action.data.cupolaEntries, isOldQuotes, action.data.cupola_price, action.data.cupola_qty);
			return {
				...state,
				action
			};
			break;
		case "BUILDINGSTYLECHANGEBYTYPE":
			return handleBuildingStyleTypeChange(state, action);
			break;
		case "resetAlltheEditValue":
			return resetAllEditValue(state, action);
		case "BUILDINGSTYLECHANGE":
			return handleBuildingStyleChange(state, action, buildingStyleChange);
			break;
		case "checkCHANGEDIMENSION":
			return checkChangeDimension(state, action);
			break;
		case "CHANGEDIMENSION":
			return changeBuildingDimensionData(state, action, changeBuildingDimension, roofStyleChange);
			break;
		case "CHANGEPORCHDIMENSION":
			changePorchDimension(state, action.value, action.str, action.secondParam, action.checkCustomDimension, roofStyleChange);
			return {
				...state,
				action
			};
			break;
		case "genratePrintImages":
			return handleGeneratePrintimages(state, action);
			break;

		case "capturebuildingImages":
			const_var.imageObj = { val: action.val, chkIndex: action.chkIndex, toRender: new Date().getTime() };

			return {
				...state,
				action
			};
			break;

		case "submitReportIssue":
			state.const_var.reportIssueID = action.response ? action.response.ticket_string : "";
			state.const_var.ticketId = action.response ? action.response.id : "";
			state.const_var.errormsg = action.errormsg ? action.errormsg : "";
			return {
				...state,
				action
			};
			break;
		case "handleReportLoader":
			state.const_var.showReportLoading = action.value;
			return {
				...state,
				action
			};
			break;

		case "manageReportIssueModal":
			state.const_var.reportIssueID = "";
			state.const_var.ticketId = "";
			state.const_var.showReportIssueModal = action.value;
			delete state.const_var.displayerrorMessage.reportIssue;
			state.const_var.errormsg = "";
			return {
				...state,
				action
			};
			break;
		case "zipCodeError":
			state.const_var.ziperrormsg = action.msg;

			return {
				...state,
				action
			};
			break;
		case "showStateField":
			state.const_var.showStateField = action.value;
			if (action.apiCallForStateVal != "") {
				state.const_var.apiCalledforState = action.apiCallForStateVal;
				state.params.p_s_n = "";
				state.params.m_s_n = "";
				state.const_var.stateManufacturerAcordingAPIDiscount = {};
			}
			return {
				...state,
				action
			};
			break;
		case "setScreenShot":
			state.const_var.setScreenshot = action.value;
			return {
				...state,
				action
			};
			break;
		case "APICalledForState":
			state.const_var.apiCalledforState = action.value;
			return {
				...state,
				action
			};
			break;
		case "updatePreQuoteErr":
			state.const_var.preQuoteError = action.value;
			if (action.resetState == true) {
				state.params.p_s_n = "";
				state.params.m_s_n = "";
				state.const_var.stateManufacturerAcordingAPIDiscount = {};
				state.const_var.bjDData = [];
			}
			return {
				...state,
				action
			};
			break;
		case "updatePostData":
			return handleUpdatePostdata(state, action);
			break;
		case "handleDescription":
			state.const_var.reportDesc = action.value;
			return {
				...state,
				action
			};
			break;
		case "setupTween":
			return handleSetupTween(state, action, TWEEN);
		case "makeDimensionUpdate":
			makeDimensionUpdateLeft(state);
			makeDimensionUpdateFront(state);
			makeDimensionUpdateBack(state);
			makeDimensionUpdateRight(state);

			return {
				...state,
				newColor: action.value
			};
			break;
		case "SETPRICINGDATAFORLEANTO":
			setPricingDataForLeanto(state, action.value, action.str, state.defaulProductLoad, {
				...centerBuildingsWallOptionsHelpers.reducerBindings,
				makeDimensionUpdateBack,
				makeDimensionUpdateFront,
				makeDimensionUpdateLeft,
				makeDimensionUpdateRight
			});
			return {
				...state,
				action
			};
			break;
		case "PRICINGLOADERFALSE":
			const_var.is_loader = false;
			state.is_checked_loader = const_var.is_loader;
			return {
				...state,
				action
			};
			break;
		case "setPricingDataForLeantoComparision":
			setPricingDataForLeantoComparision(state, action.value, action.str, state.defaulProductLoad, action.iiD);
			return {
				...state,
				newColor:
					action +
					const_var.i_g_A_y.length +
					const_var.NoCompareData1 +
					const_var.NoCompareData2 +
					action.str +
					action.iiD +
					const_var.comparisionLoadermfg1 +
					const_var.comparisionLoadermfg2 +
					params.m_s_n_1 +
					params.m_s_n_2
			};
			break;
		case "handleShowFullPageLoader":
			const_var.checkIval = 0;
			const_var.i_g_A_y = [];
			state.const_var.showProcessLoaderchk = true;
			return {
				...state,
				showFullPageLoader: state.const_var.i_g_A_y.length + const_var.isShowAlert + state + 1
			};
			break;
		case "handleExtraAddOnList":
			return {
				...state,
				newColor: action
			};
			break;
		case "RAISETICKETS":
			if (action.response == "") {
				state.const_var.comparisionLoadermfg1 = true;
			} else {
				const_var.showhideUpgradePlan = action.response;
				state.const_var.comparisionLoadermfg1 = false;
			}
			return {
				...state,
				action
			};
			break;
		case "SETCOMPARISIONBUILDINGLOADER":
			return setComparisonBuildingLoader(state, action);
			break;
		case "NoDataCompare":
			return NoCompareData(state, action);
			break;
		case "SETCOMPARISIONBUILDINGDATA":
			return setBuildingComparisonData(state, action, cuBuilding);
			break;
		case "prepareNewBuilding":
			return {
				...state,
				action
			};
		case "changeComparisonData":
			const_var.leantoCompare = const_var.ComparisionDataArray[action.iid].request_data.building.leanto;
			cuBuilding.setComparePricingData(action.iid, action.event.target.value);

			return {
				...state,
				action
			};
		case "makeComponentAction":
			makeComponentArray(state, action);
			return {
				...state,
				action
			};
		case "SETPRICINGDATA":
			setPricingData(state, action.value, state.defaulProductLoad, action.str, action.isEdit, {
				...centerBuildingsWallOptionsHelpers.reducerBindings,
				...leanToWallOptionHelpers.reducerBindings
			});
			return {
				...state,
				action
			};
			break;

		case "SELECTED_TAB":
			return handleSelectedTab(state, action);
			break;
		case "SELECTED_TAB_STATE":
			return handleSelectedTabState(state, action);

			break;

		case "SURFACECHANGE":
			return handleSurfaceChange(state, action, utils);
			break;
		case "stateManufacturerChange":
			return stateManufacturerDataChange(state, action);
			break;
		case "updateManufactureData":
			updateManufacture(state, action.payload);
			return {
				...state,
				action
			};
		case "setZipCodeVal":
			return setZipCodeValue(state, action);
			break;

		case "FULLYOPENED":
			return fullWallOpened(state, action);
			break;
		case "FULLYENCLOSED":
			return fullWallClosed(state, action);
			break;
		case "INDUVIDUALWALLCHANGE":
			centerBuildingsWallOptionsHelpers.applyCenterWallSelection(state, action.value, action.wall, {
				removeStorage: utilityStorageOptionsHelpers.clearCenterStorage,
				resetLeantoStoragePrice: (leanType) => utilityStorageOptionsHelpers.resetLeanToStoragePrice(state, leanType)
			});
			return {
				...state,

				newColor: action
			};
			break;

		case "ALLVERTICAL":
			return handleAllVerticalChange(state, action, utils);
			break;
		case "CUTPANELACTION":
			return handleCutPanelWall(state, action);
			break;
		case "handleShowWhatThis":
			return handleShowWhatThis(state, action);
			break;
		case "handleShowsummarymodal":
			return handleShowSummary(state, action);
			break;
		case "handleSummaryComapreModal":
			return handleCompareSummaryModal(state, action);
			break;

		case "handleShowComparePriceModal":
			return handleShowCompareModal(state, action);
			break;

		case "handleScreenShareModal":
			state.screenShareModal = !state.screenShareModal;

			return {
				...state,
				action
			};
			break;

		case "handleShowOverlay":
			state.isShowOverlay = action.value;

			return {
				...state,
				action
			};
			break;

		case "clickOptionTime":
			state.incClickTime = action.value;
			return {
				...state,
				action
			};
			break;

		case "handleIsResetBuildingState":
			state.isResetBuilding = !state.isResetBuilding;

			return {
				...state,
				action
			};

		case "handleActiveWallSubTab":
			state.isActiveWallSubTab = action.value;
			return {
				...state,
				action
			};
			break;

		case "handleShowPhotoModal":
			state.isShowPhotoModal = !state.isShowPhotoModal;
			if (controls.isCheckActiveTab == "doorwindow" && state.isShowPhotoModal == true) {
				const_var.activeTab = "buildingtypetab";
			}
			if (controls.isCheckActiveTab == "doorwindow" && state.isShowPhotoModal == false) {
				const_var.activeTab = "doorwindow";
			}

			return {
				...state,
				action
			};
			break;

		case "handleShowDiscountsPanel":
			state.isShowDiscountsPanel = !state.isShowDiscountsPanel;
			const_var.showDiscountBanner = state.isShowDiscountsPanel;

			return {
				...state,
				action
			};
			break;

		case "handleShowDiscountsModal":
			const priceBoxContainer = document.getElementsByTagName("body");
			if (priceBoxContainer && priceBoxContainer[0] && priceBoxContainer[0].classList.contains("active-total-price")) {
				priceBoxContainer[0].classList.remove("active-total-price");
			}
			state.isShowDiscountsModal = !state.isShowDiscountsModal;

			const_var.showOutOfRange = false;
			return {
				...state,
				action
			};
			break;

		case "handleMobileDraw":
			state.isMobileDraw = action.value;
			const_var.isMobileDraw = action.value;

			return {
				...state,
				action
			};
			break;

		case "handleShowBookDemo":
			state.isShowBookDemo = !state.isShowBookDemo;

			return {
				...state,
				action
			};
			break;

		case "handlePriceAndSummaryMobileView":
			state.selectedPiceAndSummaryMobileView = action.value;

			return {
				...state,
				action
			};
			break;

		case "handleSetManufacturer":
			state.selectedManufacturer = action.id;
			const_var.checkPickThisBuilding = true;

			return {
				...state,
				action
			};
			break;

		case "handleShowShareModal":
			state.isShowShareModal = !state.isShowShareModal;

			return {
				...state,
				action
			};
			break;

		case "handleShowfeedback":
			return handleShowfeedbackData(state, action);
			break;

		case "handleCloseBuildingModal":
			state.const_var.isShowDoorwindowmobile = !state.const_var.isShowDoorwindowmobile;
			return {
				...state,
				action
			};
			break;
		case "handlePriceBookFile":
			state.priceBookFile = action.value;

			return {
				...state
			};
			break;
		case "CheckSharingAlertBox":
			return checkSharingAlertBox(state, action);

		case "handleClose":
			return handleClose(state, action);
			break;
		case "handleCloseforDoorWindows":
			return handleCloseDoorWindow(state, action);
			break;
		case "handleOfferPriceCalculation":
			return handleOfferPriceCalculation(state, action);
			break;
		case "resetDiscountNew":
			return handleNewDiscount(state, action);
			break;
		case "DeviceCapture":
			return handleDeviceCapture(state, action);
			break;

		case "hancleClickOutside":
			state.const_var.showComponentEditBox = false;
			state.const_var.showCupolaEditBox = false;
			state.isShowEditIconSection = false;
			return {
				...state,
				action
			};
			break;
		case "TRUSSCHANGEFUNCTION":
			return handleTrussChange(state, action, cuBuilding);

		case "SELECT_TRUSS_FOR_LEAN":
			return selectTrussForLean(state, action, cuBuilding);

		case "ADDWAINSCOT":
			const_var.UpdatedPriceData.wainscot_price_changed = true;

			if (params.p_e_i != "other") const_var.UpdatedPriceData.certificate_price_changed = true;
			updateWainscot(state);
			return {
				...state,
				newColor: state.params.p_w_c_n + "updateWainscot"
			};
			break;

		case "handleAccordion":
			return handleAccordian(state, action);
			break;

		case "activeTabPanel":
			return handleActiveTabPanel(state, action);

		case "TaxDepositCalculation":
			return taxDepositCalculation(state, action);
			break;
		case "AdditionComponentAdd":
			return handleAddAdditionComponent(state, action);

		case "AddNewComponentAdd":
			return handleNewComponent(state, action);
			break;
		case "addNewTax":
			return handleTax(state, action);
			break;
		case "handleLiftRequired":
			state.params.lift_type = !params.lift_type;
			const_var.UpdatedPriceData.lifttype_price_changed = true;
			cuBuilding.cP();
			return {
				...state,
				action
			};
			break;
		case "handleInsulation":
			return handleInsulationData(state, action);
			break;
		case "handleInsulationFor":
			return handleInsulationForData(state, action);
			break;
		case "EXTRAELEMENTS": {
			return handleExtraElements(state, action, utils, ManufacturesDefaultDetails);

			break;
		}
		case "EXTRAINFORMATION":
			{
				return handleExtraInformation(state, action);
			}
			break;
		case "handleOverhang": {
			return handleOverHang(state, action);
		}

		case "handleOverhangSel":
			return handleOverHangSelection(state, action);
			break;
		case "INDUVIDUALLEANTOWALLCHANGE":
			return individuealLeanWallChange(state, action);
			break;
		case "UTILITYPRICECALCULATION":
			cuBuilding.cP();
			return {
				...state,
				newColor: action.str + action.value
			};
			break;
		case "ADDUTILITY":
			return addBuildingUtility(state, action);
			break;
		case "NOSTORAGE":
			return noBuildingUtility(state, action);
			break;

		case "ADDUTILITYFRONT":
			return addFrontUtility(state, action);
			break;
		case "ADDUTILITYBACK":
			return addBackUtility(state, action);
			break;
		case "ADDUTILITYLEFT":
			return addLeftUtility(state, action);
			break;
		case "ADDUTILITYRIGHT":
			return addRightUtility(state, action);
			break;
		case "UTILITYLENGHTCHANGE":
			return utilityChangeByLength(state, action);

			break;

		case "commonConfirmationAlert":
			return handleConfirmAlert(state, action);
			break;
		case "alertCancel":
			return handleAlertCancel(state, action);
			break;

		case "checkChangeBuildingRoof":
			return checkChangeBuildingRoof(state, action);
			break;

		case "changeBuildingRoof":
			return changeBuildingRoofData(state, action, changeBuildingRoofHelper);
		case "handleSidePanel":
			state.const_var.isActiveSlide = !state.const_var.isActiveSlide;
			document.querySelector("body").classList.toggle("active-left-panel");
			cuComponent.onResize();
			setTimeout(function () {
				cuComponent.onResize();
			}, 1000);
			return {
				...state,
				action
			};
			break;
		case "CheckSnowLoadBuilding":
			return checkSnowBuilding(state, action);
			break;

		case "cloneComponent":
			return handleCloneComponent(state, action);
		case "toggleActionForUtility":
			return toggleActionForUtility(state, action);
			break;
		case "addCustomComponent":
			return handleCustomComponent(state, action, addCustomComponent);
			break;
		case "handleBreezawayFrameAndStorages":
			updateBreezewayFrameAndStorages(action, Number(action.value), undefined);
			return {
				...state,
				action
			};
			break;
		case "ADD_DOOR_COMPONENT":
			return handleAddDoorComponent(state, action);
			break;
		case "setPricingForSurcharge":
			cuBuilding.cP();
			return {
				...state,
				action
			};
		case "setPricingForComponent":
			return SetPricingForComponent(state, action, cuBuilding);
			break;
		case "showDoorWindowsPrompt":
			const_var.isShowAlert = true;

			const_var.alertUsedFor = "noSpaceForComponent";
			const_var.showComponentEditBox = false;
			return {
				...state,
				newColor: const_var.isShowAlert + const_var.alertUsedFor,
				action
			};
		case "changeComponent":
			return changeComponentData(state, action);
			break;
		case "changeComponentSize":
			return chnageComponentSize(state, action);
			break;

		case "UPDATE_DOOR_WINDOW_EDIT_ICONS":
			return updateDoorWindowIcons(state, action, activeWallP, newState);
			break;

		case "DISABLE_DOOR_WINDOW_EDIT_ICONS":
			return {
				...state,
				doorWindowIconsPos: []
			};
			break;

		case "CAMERA_FOCUS_ON_WALL":
			state.params.activeWall = action.value;
			state.const_var.focusedSection = cuComponent.wallnameBySec[action.value];

			cuComponent.cameraFocusOnWall(state, action.value);
			return {
				...state,
				action
			};
			break;
		case "showSingleSlope":
			return showSingleSlope(state, action, showSingleSlope);
			break;
		case "hasDoublelegBaiserail":
			return hasDoublelegBaiserail(state, action, cuBuilding);
			break;
		case "handleClickForFrameValue":
			return handleSetFramevalue(state, action);
			break;

		case "editComponentSize":
			return handleEditComponentSize(state, action);
			break;
		case "headerSealChainHoistAction":
			return headerSealChainHoistAction(state, action);
			break;
		case "confirmStateAction":
			state.const_var.confirmState = !state.const_var.confirmState;
			return {
				...state,
				newColor: state.const_var.confirmState
			};
			break;
		case "onSubmitState":
			onSubmitState(state, action.event);
			return {
				...state,
				newColor: state.const_var.confirmState + action.event
			};
			break;
		case "Update_estimator_QuestionAnswer":
			const_var.estimator_QuestionAnswer[action.key].options.map((val, i) => {
				const_var.estimator_QuestionAnswer[action.key].options[i].is_checked = false;
			});
			const_var.estimator_QuestionAnswer[action.key].options[action.key1].is_checked = true;
			return {
				...state,
				action
			};
			break;
		case "showInsulationAction":
			state.const_var.showInsulation = !state.const_var.showInsulation;
			if (state.const_var.showInsulation == false) {
				state.const_var.showDefaultInsullation = false;
				state.params.p_r_o = false;
			}
			cuBuilding.cP();
			return {
				...state,
				newColor: state.const_var.showInsulation
			};
			break;
		case "checkChangeLeantoPosition":
			return checkChangeLeantoPosition(state, action);
			break;
		case "changeLeantoPosition":
			return chnageLeanToPosition(state, action, cuComponent);
			break;
		case "showCenterBuilding":
			return handleShowCenterBuilding(state, action, cuBuilding);
			break;
		case "wallSelection":
			if (action.key == "center") {
				const_var.wallSelection.centerBuildingWall = action.value;
				const_var.wallSelection.leanToWall = "select";
			} else {
				const_var.wallSelection.centerBuildingWall = "select";
				const_var.wallSelection.leanToWall = action.value;
			}

			return {
				...state,
				wallSelection: action
			};
			break;
		case "addLeantoSection":
			{
				return handleAddLeantoSection(state, action, utils, const_var, params, cuBuilding, cuComponent, centerBuildingsWallOptionsHelpers.syncCenterWallOptions, leanToWallOptionHelpers.syncLeanToWallOptions);
			}

			break;
		case "addLeantoPorches":
			{
				return handleLeanToPorcheSection(
					state,
					action,
					utils,
					const_var,
					params,
					cuBuilding,
					cuComponent,
					centerBuildingsWallOptionsHelpers.syncCenterWallOptions,
					leanToWallOptionHelpers.syncLeanToWallOptions,
					updatePorchLengths
				);
			}

			break;
		case "endLeantosForTubulerBuildingMnf":
			return {
				...state,
				action
			};
			break;
		case "AddandRemoveComponent":
			return handleAddRemoveComponent(state, action);
			break;
		case "setPriceCompareForNonLoggedIn": {
			return SetPriceCompareForNonLoggedIn(state, action);
		}
		case "discountBannerAction": {
			setDiscount(state, action);
			return {
				...state,
				newColor: state.discount_Offers + state.isShowDiscountsPanel + new Date()
			};
		}
		case "STATE_QUOTE_NON_LOGGED_IN_COMPARE":
			{
				state.nonLoggedInpriceCompareData[action?.key]?.forEach((item) => {
					if (item?.id == action?.manufactureId) {
						item.manufactureStateQuote = action.value;
					}
				});
				return {
					...state,
					nonLoggedInpriceCompareData: state.nonLoggedInpriceCompareData
				};
			}
			break;
		case "resetDiscountBanner": {
			state.discount_banner = false;

			return {
				...state,
				newColor: state.discount_banner
			};
		}
		case "setDealerStateList":
			{
				setDealerStateList(state, action, const_var);
				return {
					...state,
					action,
					newColor: state.const_var.bjD
				};
			}
			break;
		case "commonsActionforAttribute":
			return handleCommonAttribute(state, action);
			break;
		case "callTaxApiAndCalculatePrice":
			return handleTaxApicall(state, action);
			break;
		case "ShowMeasure":
			return handleShowMeasure(state, action);
		case "isOpenBookaDemo":
			return handleBookDemo(state, action);
			break;

		case "UsertourAction":
			state.const_var.iswelcomeModal = false;
			state.const_var.isOpenUserTour = action.value;
			state.const_var.startTourNumber = action.opennumber;
			state.const_var.currentStepTour = +action.key + 1;
			return {
				...state,
				newColor: action.value + action.key + action.opennumber
			};
			break;

		case "isOpenWelcomeModal":
			state.const_var.iswelcomeModal = action.value;
			if (action.key == "actionclose") {
				localStorage.setItem("WelcomePopupClosed", "true");
			}

			return {
				...state,
				newColor: action.value + action.key
			};
			break;

		case "isOpenLayoutDesignModal":
			state.const_var.isLayoutDesign = action.value;

			return {
				...state,
				newColor: action.value + action.key
			};
			break;

		case "showMoreLessSidesAndEnds":
			showMoreLess(action.position);
			return {
				...state,
				action
			};
			break;
		case "toggleCustomCheckboxChange":
			return handleToggleCheckbox(state, action);
		case "setBuildingFlags":
			return handleBuildingFlag(state, action);
		case "handleProfileModal":
			const_var.showProfileModal = action.value;
			if (const_var.showProfileModal == true) {
				document.querySelector("body").classList.add("handburger-active");
			} else {
				document.querySelector("body").classList.remove("handburger-active");
			}
			return {
				...state,
				action
			};
		case "handleFeedbackMandatory":
			const_var.isFeedbackFieldMandatory = action.value;

			if (action.value == false) {
				const_var.displayerrorMessage.feedback_email = "";
				const_var.displayerrorMessage.feedback_first_name = "";
				const_var.displayerrorMessage.feedback_last_name = "";
				const_var.displayerrorMessage.feedback_phone_number = "";
			}
			return {
				...state,
				action
			};
		case "setNavtab":
			if (action.key == "input") {
				const_var.navEventKey.leanto = action.value.target.id;
			}
			if (action.key == "nav") {
				const_var.navEventKey.leanto = action.value;
			}

			return {
				...state,
				action
			};
		case "fullyWrapClick":
			return fullWrapClick(state, action);

		case "fullViewbuild":
			return fullBuildingView(state, action);

		case "showStateOrManufactureChangeModal":
			return handleManufacturerModal(state, action);

		case "handleStateManufactureChange":
			return handleManufacturerChange(state, action);
		case "GlobalZipUpdate":
			return globalZipState(state, action);

		case "setLeanToLegPosObj":
			const_var.leanToLegPosObj[action.key] = action.value;

			return {
				...state,
				action
			};

		case "updateGableBackWall":
			return {
				...state,
				action
			};

		case "handleDealerDiscountBannerVisible":
			state.isDealerDiscountBannerVisible = action.value;
			return {
				...state,
				action
			};
		case "handleDeletedStateManuModal":
			state.isShowDeletedStateManuModal = action.value;

			if (document.querySelector("body").classList.contains("active-modal-loader")) {
				document.querySelector("body").classList.remove("active-modal-loader");
			}
			state.const_var.is_loader = false;
			return {
				...state,
				newColor: action.value
			};

		case "SELECT_LEAN_BUILDING":
			return selectleanBuilding(state, action, cuComponent);

		case "SELECT_CENTER_BUILDING":
			return selectCenterBuilding(state, action, utils);

		case "handleCompanySelection":
			return handleCompanySelection(state, action);

		case "handleDeletedStateManuModal":
			return handleDeleteStateModal(state, action);

			break;
		case "handleLoftChange":
			return handleLoftChange(state, action);
			break;
		case "handleShowAlertBox":
			state.const_var.isShowAlert = true;
			state.const_var.alertUsedFor = action.value;
			return {
				...state,
				action
			};
	}

	return newState;
};
window.initialstate = initialState;

window.THREE = THREE;
const { buildingTypeChange, buildingStyleChange, roofStyleChange } = createBuildingStyleChanges({
	THREE,
	params,
	const_var,
	utils,
	controls,
	cuBuilding,
	cuComponent,
	updateBreezewayFrameAndStorages,
	ManufacturesDefaultDetails,
	makeDimensionArray,
	makeDimensionUpdateFront,
	makeDimensionUpdateBack,
	makeDimensionUpdateLeft,
	makeDimensionUpdateRight,
	reSelExtEle,
	...centerBuildingsWallOptionsHelpers.reducerBindings,
	...leanToWallOptionHelpers.reducerBindings,
	hidePriceForGableLeanTos
});
export default reducer;
